import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../../Context/UserContext";
import Button from "../../../../Reusable/Button";
import toast from "react-hot-toast";
import { BaseURL } from "../../../../Reusable/BaseURL";
import IndentCreatePageForm from "../../../../purchaseFormPages/IndentCreatePageForm";
import { SeveritySelect } from "../../../../Reusable/SeveritySelect";
import MyTextarea from "../../../../Reusable/MyTextarea";
import { XMarkIcon } from "@heroicons/react/24/outline";

import ClickOutHandler from "react-clickout-handler";
import { IndentCreateDivisionSelect } from "../../../../Reusable/IndentCreateDivisionSelect";
import MyInput from "../../../../Reusable/MyInput";
import { ItemByDivisionSelect } from "../../../../Reusable/ItemByDivisionSelect";
import { BrandByItemSelect } from "../../../../Reusable/BrandByItemSelect";
import { Spinner } from "../../../../Reusable/Spinner";
import { IndentUnitSelect } from "../../../../Reusable/IndentUnitSelect";
import IndentUpdatePageForm from "../../../../purchaseFormPages/IndentUpdatePageForm";
import { useNavigate } from "react-router-dom";
import { IndentItemSeveritySelect } from "../IndentItemSeveritySelect";
import { UpdIndentUnitSelect } from "./UpdIndentUnitSelect";
import { UpdBrandByItemSelect } from "./UpdBrandByItemSelect";
import { UpdItemByDivisionSelect } from "./UpdItemByDivisionSelect";
import { UpdIndentItemSeveritySelect } from "./UpdIndentItemSeveritySelect";

export default function UpdateIndent() {
  const {
    darkTheme,
    loginData,
    indentAddItemLoading,
    setIndentCreateItemId4Upd,
    indentUpdateData,
    indentUpdateDataItems,
    setIndentUpdateData,
    setIndentUpdateDataItems,
  } = useContext(UserContext);

  useEffect(() => {
    if (indentUpdateData) {
      setUnsavedIndentItem(indentUpdateData.items);

      setDate(indentUpdateData.date || "");
      // setSeverity(indentUpdateData.severity || "");
      setRemark(indentUpdateData.remarks || "");

      setDivision(indentUpdateData.division || "");
      setIndentDocCode(indentUpdateData.code || "");
    }
  }, [indentUpdateData.division]);

  const navigate = useNavigate();

  const [division, setDivision] = useState("");
  const [item, setItem] = useState("");
  const [brand, setBrand] = useState("");
  const [unit, setUnit] = useState("");
  const [qty, setQty] = useState("");
  const [date, setDate] = useState("");
  // const [severity, setSeverity] = useState("");
  const [itemSeverity, setItemSeverity] = useState("Normal");
  const [remark, setRemark] = useState("");
  const [indentDocCode, setIndentDocCode] = useState("");

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);

  const [addMoreToggle, setAddMoreToggle] = useState(false);
  const [changingSelect, setChangingSelect] = useState(false);

  const [submitAction, setSubmitAction] = useState("submit");
  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [itemSubmitDisable, setItemSubmitDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);

  const [unsavedIndentItem, setUnsavedIndentItem] = useState([]);
  const [allIndentItem, setAllIndentItem] = useState([]);
  const [cacheItemId, setCacheItemId] = useState("");
  const [myCacheDivision, setMyCacheDivision] = useState("");

  useEffect(()=>{
    setItemSeverity("Normal")
  },[])

  function indentSelectedUpdData() {
    setSpinner(true);
    fetch(`${BaseURL}/purchase/indent/get/${indentUpdateData.id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((selectedRecord) => {
        if (selectedRecord.status) {
          // setChangingSelect(true);
          // setAddMoreToggle(true);
          // setSubmitAction("update");
          // setDivision(selectedRecord.data.division || "");
          // setItem(selectedRecord.data.item_name || "");
          // setBrand(selectedRecord.data.brand || "");
          // setUnit(selectedRecord.data.unit || "");
          // setQty(selectedRecord.data.qty || "");

          setSpinner(false);
          setIndentUpdateData(selectedRecord.data || {});
          setIndentUpdateDataItems(selectedRecord.data.items || []);
        }
        if (selectedRecord.status === false) {
          setSpinner(false);
        }
      });
    // setChangingSelect(false);
  }

  // async function getUnsavedItemList() {
  //   const res = await fetch(`${BaseURL}/purchase/indent/getcache`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((resdata) => resdata.json())
  //     .then((createRes) => {
  //       if (createRes.status) {
  //         const cacheItems =
  //           createRes.data !== null ? createRes.data.items : [];
  //         const reverseCacheItems = cacheItems.reverse();
  //         // setUnsavedIndentItem(createRes.data.items || []);
  //         setUnsavedIndentItem(reverseCacheItems);

  //         const mygetdivision =
  //           createRes.data !== null ? createRes.data?.items[0] : {};
  //         const cacheDivision = mygetdivision?.division || "";
  //         setMyCacheDivision(cacheDivision || "");

  //         setSpinner(false);
  //       }
  //     });
  // }

  // async function getAllIndentCreated() {
  //   const res = await fetch(`${BaseURL}/purchase/indent/getall`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((resdata) => resdata.json())
  //     .then((createRes) => {
  //       if (createRes.status) {
  //         setAllIndentItem(createRes.data);
  //         setSpinner(false);
  //       }
  //     });
  // }

  // useEffect(() => {
  //   getAllIndentCreated();
  //   getUnsavedItemList();
  // }, []);

  // ADD INDENT ITEM
  async function addIndentItem(e) {
    e.preventDefault();

    setItemSubmitDisable(true);
    if (division !== "") {
      // const formData = {
      //   item_id: item.value || "",
      //   brand: brand.label || "",
      //   unit: unit.label || "",
      //   qty: qty,
      //   indent_id: indentUpdateData.id,
      // };

      const formData = new FormData();
      formData.append("severity", itemSeverity.value || "");
      formData.append("item_id", item.value || "");
      formData.append("brand", brand.label || "");
      formData.append("unit", unit.label || "");
      formData.append("qty", qty || "");
      formData.append("indent_id", indentUpdateData.id || "");

      // console.log("item-add-data-upd", formData);

      const res = await fetch(`${BaseURL}/purchase/indent/saveitem`, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${loginData.token}`,
          // "Content-Type": "application/json",
        },
      })
        .then((resdata) => resdata.json())
        .then((createRes) => {
          if (createRes.status) {
            setAddMoreToggle(false);
            // getUnsavedItemList();
            indentSelectedUpdData();

            setItem("");
            setBrand("");
            setUnit("");
            setQty("");
            toast.success("Added on lists");
            setItemSubmitDisable(false);
          }
          if (createRes.status === false) {
            setItemSubmitDisable(false);
          }
          if (createRes?.error?.message.item_id) {
            toast.error(createRes.error.message.item_id);
          } else if (createRes?.error?.message.brand_id) {
            toast.error(createRes.error.message.brand_id);
          } else if (createRes?.error?.message.unit) {
            toast.error(createRes.error.message.unit);
          } else if (createRes?.error?.message.qty) {
            toast.error(createRes.error.message.qty);
          } else if (createRes?.error?.message.severity) {
            toast.error(createRes.error.message.severity);
          }
        });
    } else {
      toast.error("First Select Division.!");
    }
  }

  // create
  // const itemId = unsavedIndentItem.map((item, index) => item.id);
  async function createDivision(e, id) {
    e.preventDefault();
    if(unsavedIndentItem.length <= 0){
      toast.error("Please add items before submit.");
      return;
    }
    setSubmitDisable(true);
    const formData = {
      date: date,
      // severity: severity.value,
      remarks: remark,
      division: division.value,
    };

    const res = await fetch(`${BaseURL}/purchase/indent/update/${id}`, {
      method: "PATCH",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          // getUnsavedItemList();
          setIndentUpdateData({});
          navigate("/purchase/pending-indent-view");
          toast.success("Success");
          setDivision("");
          setItem("");
          setBrand("");
          setUnit("");
          setQty("");

          setDate("");
          // setSeverity("");
          setRemark("");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.date) {
          toast.error(createRes.error.message.date);
        } else if (createRes?.error?.message.severity) {
          toast.error(createRes.error.message.severity);
        }
      });
  }

  function editBtn(id) {
    setEditDisable(true);
    fetch(`${BaseURL}/purchase/indent/getitem/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((selectedRecord) => {
        if (selectedRecord.status) {
          setChangingSelect(true);
          setAddMoreToggle(true);
          setSubmitAction("update");

          setDivision(selectedRecord.data.division || "");
          setItem(selectedRecord.data.item_name || "");
          setItemSeverity(selectedRecord.data.severity || "");
          setBrand(selectedRecord.data.brand || "");
          setUnit(selectedRecord.data.unit || "");
          setQty(selectedRecord.data.qty || "");
          setEditDisable(false);
        }
        if (selectedRecord.status === false) {
          setEditDisable(false);
        }
      });
    setChangingSelect(false);
  }
  // UPDATE A RECORD
  async function updateIndentItem(e, id) {
    e.preventDefault();
    setUpdateDisable(true);
    if (division !== "") {
      const formData = {
        severity: itemSeverity.value || "",
        item_id: item.value || "",
        brand_id: brand.brand_id || "",
        unit_id: unit.value || "",
        qty: qty || "",
      };
      const updRes = await fetch(
        `${BaseURL}/purchase/indent/updateitem/${id}`,
        {
          method: "PATCH",
          body: JSON.stringify(formData),
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${loginData.token}`,
            "Content-Type": "application/json",
          },
          // body: JSON.stringify({name: divisionName}),
        }
      )
        .then((res) => res.json())
        .then((upd) => {
          if (upd.status) {
            // getUnsavedItemList();
            indentSelectedUpdData();
            setGetId(0);
            setItem("");
            setBrand("");
            setUnit("");
            setQty("");

            setSubmitAction("submit");
            setAddMoreToggle(false);
            toast.success("Updated");
            setUpdateDisable(false);
          }
          if (upd.status === false) {
            setUpdateDisable(false);
          }
          if (upd?.error?.message.item_id) {
            toast.error(upd.error.message.item_id);
          } else if (upd?.error?.message.brand_id) {
            toast.error(upd.error.message.brand_id);
          } else if (upd?.error?.message.unit) {
            toast.error(upd.error.message.unit);
          } else if (upd?.error?.message.qty) {
            toast.error(upd.error.message.qty);
          } else if (upd?.error?.message) {
            toast.error(upd.error.message);
          }
        });
    }
  }

  function cancelUpdate() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setSubmitAction("submit");
    setItem("");
    setBrand("");
    setUnit("");
    setQty("");

    setSubmitDisable(false);
    setEditDisable(false);
    setUpdateDisable(false);
    setItemSubmitDisable(false);
    // setDivision("");
    // setDate("");
    // setSeverity("");
    // setRemark("");

    setIndentUpdateData({});
    navigate("/purchase/view-indent");
  }

  function cancelPopup() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setAddMoreToggle(false);
    setItem("");
    setBrand("");
    setUnit("");
    setQty("");

    setSubmitDisable(false);
    setEditDisable(false);
    setUpdateDisable(false);
    setItemSubmitDisable(false);
    // setDivision("");
    // setDate("");
    // setSeverity("");
    // setRemark("");
    setSubmitAction("submit");
  }

  function popupCreateIndentOnClickOut() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setAddMoreToggle(false);
    setItem("");
    setBrand("");
    setUnit("");
    setQty("");
    setSubmitAction("submit");
    // setDivision("");
  }

  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Update Indent
          </div>

          <div className="mb-2">
            <div className="grid grid-cols-1 md:grid-cols-2">
              {/* LEFT PART  */}
              <div className="px-2 w-full mb-6">
                <form>
                  <div className="grid grid-cols-2 gap-x-2 md:gap-x-6">
                    <div className="mb-2 w-full">
                      <label className="!text-lg !font-bold">Indent No.</label>
                      <textarea
                        rows={2}
                        type="text"
                        // disabled={true}
                        readOnly
                        className={`border uppercase rounded-lg py-[8px] px-3 outline-none border-gray-500 text-gray-500 font-bold bg-[#ffff] w-full`}
                        value={indentDocCode}
                        onChange={(e) => setIndentDocCode(e.target.value)}
                      />
                    </div>
                    <div className="mb-2 w-full">
                      <label>
                        Division : {/* {indentUpdateData.division}{" "} */}
                        {/* <small className="text-red-500">
                          (You can&#39;t change)
                        </small> */}
                      </label>
                      <input
                        type="text"
                        // disabled={true}
                        readOnly
                        className={`border block uppercase rounded-lg py-[8px] px-3 outline-none border-gray-500 text-gray-500 font-bold bg-[#ffff] w-full`}
                        value={indentUpdateData.division}
                      />

                      {/* <IndentCreateDivisionSelect
                      selectedOption={
                        indentUpdateData?.division
                          ? indentUpdateData.division
                          : division
                      }
                      setSelectedOption={setDivision}
                      changingSelect={changingSelect}
                      setEmpty={setItem}
                      addMoreToggle={addMoreToggle}
                      unsavedIndentItem={unsavedIndentItem}
                      setUnsavedIndentItem={setUnsavedIndentItem}
                      myCacheDivision={myCacheDivision}
                      disabled={true}
                      updDivision={indentUpdateData?.division}
                    /> */}
                    </div>
                    <div className="mb-2">
                      <label className="mr-2 block mb-[4px]">Date</label>
                      <input
                        className={`py-1.5 rounded-lg px-3 outline-none border ${
                          darkTheme
                            ? "bg-gray-700 border-gray-500"
                            : "bg-white border-gray-500"
                        }`}
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        type="date"
                        name="date"
                      />
                    </div>

                    {/* <div className="mb-2 w-full">
                    <label>Severity : {severity.label}</label>
                    <SeveritySelect
                      selectedOption={
                        indentUpdateData?.severity
                          ? indentUpdateData.severity
                          : severity
                      }
                      setSelectedOption={setSeverity}
                    />
                  </div> */}
                    <MyTextarea
                      label="Remark"
                      type="text"
                      className="w-full"
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                    />
                  </div>
                </form>
              </div>
              {/* END LEFT PART  */}

              {/* RIGHT PART  */}
              <div className="bg-[#8CDDCD] rounded-xl p-3">
                <div className="mb-2 grid grid-cols-2 gap-x-2">
                  <div className="mb-2 w-full">
                    <label>
                      Severity <span className="text-red-500 font-bold">*</span>
                    </label>
                    <UpdIndentItemSeveritySelect
                      selectedOption={itemSeverity}
                      setSelectedOption={setItemSeverity}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>
                  <div className="mb-2">
                    <label>Item</label>
                    <UpdItemByDivisionSelect
                      divisionLabel={division && division}
                      selectedOption={item}
                      setSelectedOption={setItem}
                      setEmpty={setBrand}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>
                  <div className="mb-2">
                    <label>Brand</label>
                    <UpdBrandByItemSelect
                      itemItemId={item && item.value}
                      selectedOption={brand}
                      setSelectedOption={setBrand}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>
                  <div className="mb-2">
                    <label>Unit</label>
                    <UpdIndentUnitSelect
                      selectedOption={unit}
                      setSelectedOption={setUnit}
                      unitByItem={item}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>
                  <MyInput
                    value={qty}
                    // value={qty}
                    onChange={(e) => setQty(e.target.value)}
                    label="Quantity"
                    type="number"
                    className="w-full"
                  />
                </div>
                <div className="flex items-center justify-center gap-1">
                  {submitAction === "submit" && (
                    <Button
                      disabled={itemSubmitDisable}
                      type="submit"
                      onClick={(e) => addIndentItem(e)}
                      className="!bg-yellow-600"
                    >
                      {itemSubmitDisable ? "Wait.." : "Add to list"}
                    </Button>
                  )}
                  {submitAction !== "submit" && (
                    <Button
                      disabled={updateDisable}
                      type="submit"
                      onClick={(e) => updateIndentItem(e, getId)}
                      className="!bg-yellow-600"
                    >
                      {updateDisable ? "Wait.." : "Update Item"}
                    </Button>
                  )}
                  <Button
                    onClick={() => cancelPopup()}
                    className="!bg-gray-200 !text-black"
                  >
                    Cancel
                  </Button>
                </div>
              </div>

              {/* END RIGHT PART  */}
            </div>
          </div>

          <div className="w-full px-2">
            <IndentUpdatePageForm
              editBtn={editBtn}
              // firstPageList={getUnsavedItemList}
              links={links}
              firstPage={
                indentUpdateDataItems
                // ? indentUpdateDataItems
                // : unsavedIndentItem
              }
              setGetId={setGetId}
              spinner={spinner}
              totalNo={totalNo}
              from={from}
              to={to}
              addMoreToggle={addMoreToggle}
              setAddMoreToggle={setAddMoreToggle}
              indentSelectedUpdData={indentSelectedUpdData}
              editDisable={editDisable}
            />
          </div>

          {submitAction === "submit" && (
            <div className="flex items-center justify-center gap-x-1 mt-2">
              <Button
                disabled={submitDisable}
                // disabled={submitDisable || unsavedIndentItem.length <= 0}
                type="submit"
                onClick={(e) => createDivision(e, indentUpdateData.id)}
              >
                {submitDisable ? "Wait.." : "Update"}
              </Button>
              <Button type="button" onClick={() => cancelUpdate()}>
                Cancel
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
